import { Directive, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MapComponent } from './map.component';
import { gmapsLoadPromise } from '../lib/google-maps';
import { BLUE_50, GREEN_20 } from '@app/lib/colors';

interface IStyle {
  fillColor: string;
  fillOpacity: number;
  path: google.maps.LatLng[];
  strokeColor: string;
  strokeOpacity: number;
  strokeWeight: number;
}

@Directive({
  selector: 'map-polygon',
})
export class MapPolygonDirective implements OnInit, OnChanges, OnDestroy {
  @Input() public coords;
  @Input() public autoZoom;
  @Input() public color = GREEN_20;
  @Input() public zIndex = 0;
  @Input() public width = 0;
  @Input() public fillColor = BLUE_50;
  @Input() public fillOpacity = 0.4;
  @Input() public strokeOpacity = 1.0;

  private gmaps: any;
  private id: string;
  private polygonObj: google.maps.Polygon;

  constructor(@Inject(MapComponent) private map: MapComponent) {}

  public ngOnInit() {
    this.map.createMapPromise.then(() => {
      this.gmaps = this.map.gmaps;
      this.create();
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    const coords = changes.coords;
    if (this.gmaps && this.id && !coords.firstChange && coords.currentValue.length !== coords.previousValue.length) {
      this.polygonObj.setPath(this.coords.map(c => new this.gmaps.LatLng(c.lat, c.lng)));
    }
  }

  public ngOnDestroy() {
    this.remove();
  }

  private remove(): void {
    if (this.id) this.map.removeShape(this.id);
  }

  private get styles(): IStyle {
    return {
      strokeColor: this.color,
      strokeOpacity: this.strokeOpacity,
      strokeWeight: this.width,
      fillColor: this.fillColor,
      fillOpacity: this.fillOpacity,
      path: this.coords.map(c => new this.gmaps.LatLng(c.lat, c.lng)),
    };
  }

  private create(): void {
    const polygonOptions: IStyle = this.styles;
    const options = {
      autoZoom: this.autoZoom === undefined ? true : this.autoZoom,
    };
    this.polygonObj = new this.gmaps.Polygon(polygonOptions);
    this.id = this.map.addShape(this.polygonObj, options, 'polygon');
  }
}
